import Nullstack from 'nullstack';
export default function IconScooterElectric({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-scooter-electric",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
  }), "   ", Nullstack.element("path", {
    d: "M10 4l-2 4h3l-2 4"
  }), " ");
}